import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { FormattedMessage } from "react-intl";

interface DialogConfirmWarningProps {
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
  cancelText?: string | React.ReactNode;
  okText?: string | React.ReactNode;
  testId?: string;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 440,
        width: "100%",
        borderRadius: 16
      },
      "& .MuiDialogTitle-root": {
        padding: 24
      },
      "& .MuiDialogContent-root": {
        paddingTop: 5
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      }
    },
    title: {
      color: theme.palette.error.light
    },
    btnAction: {
      height: 48,
      "&.MuiButton-containedPrimary .MuiTypography-root": {
        color: "#ffffff"
      }
    }
  }),
  { name: "DialogConfirmDelete" }
);

const DialogConfirmWarning: React.FC<DialogConfirmWarningProps> = ({
  onCancel,
  onConfirm,
  open,
  title,
  content,
  cancelText,
  okText,
  testId
}) => {
  const classes = useStyles({});
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      className={classes.root}
      data-testid={testId ?? "dialogConfirmWarning"}
    >
      {title ? (
        <DialogTitle>
          <MyTypography variant="h6" className={classes.title}>
            {title}
          </MyTypography>
        </DialogTitle>
      ) : (
        ""
      )}
      {content ? (
        <DialogContent>
          <MyTypography variant="body2">{content}</MyTypography>
        </DialogContent>
      ) : (
        ""
      )}
      <DialogActions disableSpacing={true}>
        <Button
          id="cancelButton"
          data-testid="cancelButton"
          color="primary"
          variant="outlined"
          className={classes.btnAction}
          fullWidth={true}
          onClick={onCancel}
        >
          <MyTypography variant="body1">
            {cancelText ? (
              cancelText
            ) : (
              <FormattedMessage defaultMessage="ยกเลิก" />
            )}
          </MyTypography>
        </Button>
        <Button
          id="confirmButton"
          data-testid="confirmButton"
          color="primary"
          variant="contained"
          className={classes.btnAction}
          fullWidth={true}
          onClick={onConfirm}
        >
          <MyTypography variant="body1">
            {okText ? okText : <FormattedMessage defaultMessage="ยืนยัน" />}
          </MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmWarning;
